import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import CardView from '../CardView/CardView';
import DummyView from '../CardView/DummyCard';
import {
  CloseSideBarSVG,
  ExpandSideBarSVG,
} from '../../../../img/bottom-sidebar/BottomSideBarSVG';
import { useDispatch } from 'react-redux';
import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../redux/admin/priceCompareSlice';
import './BottomSideBar.scss';
import { useNavigate } from 'react-router-dom';

const BottomSideBar = ({ selectedCheckedItems, selectedCheckedRowData }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isItemsSelected = selectedCheckedItems.length > 0;
  const isCompareDisabled = selectedCheckedItems.length < 2;
  const staticArray = Array(3).fill(1);

  const [open, setOpen] = useState(false);

  const toggleSideBarHandler = () => {
    setOpen(!open);
  };

  const removeAll = () => {
    dispatch(setSelectedCheckedItems([]));
    dispatch(setSelectedCheckedRowData([]));
  };

  useEffect(() => {
    if (!isItemsSelected) {
      setOpen(false);
    }
  }, [isItemsSelected]);

  useEffect(() => {
    //Need to clear the selected items while unmounting
    return () => {
      //removeAll();
    };
  }, []);

  const handleCompareResult = () => {
    navigate('/admin/price-compare/show-result', {
      state: {
        from: 'search',
      },
    });
  };

  return (
    <div
      aria-label="compare price tool panel"
      className={`bottom-sidebar-wrapper ${open && 'collapsed-bar'} ${
        isItemsSelected ? 'sidebar-open' : 'sidebar-close'
      }`}
    >
      <div className="container">
        <div className="top-section">
          <div className="top-section-wrapper">
            <div className="blueTitle">
              {t('member.price_comparison.heading_text_compare')}{' '}
              {open && (
                <span className="mobile-selected-count">
                  ({selectedCheckedItems.length})
                </span>
              )}
            </div>
            <div
              className={`arrow-bg ${open && 'down-arrow'}`}
              role="button"
              aria-label="Click to expand and collapse the panel"
              onClick={() => toggleSideBarHandler()}
              tabIndex={0}
              aria-expanded={!open}
            >
              <ExpandSideBarSVG />
            </div>
          </div>
          {open && (
            <div role="status" className="top-sub-section-collapsed">
              You have selected {selectedCheckedItems.length} out of 3 options.
            </div>
          )}
          <div className="right-section">
            <div
              className="remove-all"
              role="button"
              onClick={() => removeAll()}
            >
              Remove All{' '}
              <span className="sr-only"> the selected providers</span>
            </div>
            <div
              aria-label="Remove all the selected providers and close the panel"
              role="button"
              className="closeIconPosition"
              onClick={() => removeAll()}
            >
              <CloseSideBarSVG className="closeIcon" />
            </div>
          </div>
        </div>
        <div className="middle-section">
          {selectedCheckedRowData && (
            <div className="card-wrapper">
              {staticArray.map((item, index) => (
                <div
                  className={`${
                    selectedCheckedRowData && selectedCheckedRowData[index]
                      ? 'card-item card-info-item'
                      : 'card-item card-dummy-item'
                  }`}
                  key={`item-${index}`}
                >
                  {selectedCheckedRowData && selectedCheckedRowData[index] ? (
                    <CardView data={selectedCheckedRowData[index]} />
                  ) : (
                    <DummyView />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="bottom-section">
          <GenericButton
            buttonDisabled={true}
            ariaLabel={
              isCompareDisabled
                ? 'Select a minimum of 2 and maximum of 3 providers'
                : 'Click to compare the selected providers'
            }
            onClick={() => {
              handleCompareResult();
            }}
          >
            Generate Cost
          </GenericButton>
          <div className="remove-all" onClick={() => removeAll()}>
            Remove All
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSideBar;
